import gql from 'graphql-tag';

export class ContentLinkQueries {
  static previewQuery = gql`
    query PreviewContentLinkBlock($targetUrl: String!) {
      previewContentLinkBlock(url: $targetUrl) {
        url
        title
        thumbUrl
        description
      }
    }
  `;

  static uploadQuery = gql`
    query ContentLinkBlockUpload($blockId: String!) {
      contentLinkBlockUpload(id: $blockId)
    }
  `;

  static loadDetailsQuery = gql`
    query LoadContentLinkBlockDetails($id: String!) {
      contentLinkBlock(id: $id) {
        id
        entityId
        userId
        url
        title
        description
        thumbExtension
        buttonText
        thumbUrl
      }
    }
  `;

  static loadImageQuery = gql`
    query LoadContentLinkBlockDetails($id: String!) {
      contentLinkBlock(id: $id) {
        id
        thumbUrl
      }
    }
  `;
}
